import React, { Component } from 'react';
import Form from 'react-bootstrap/lib/Form';
import { toastr } from 'react-redux-toastr';
import map from 'lodash.map';
import axios from 'axios';
import { Formik } from 'formik';
import {
	ThematicAreaDropdownOption,
	DefaultOffice,
	DistrictDropdownOption,
	InitiativeType
} from '../../../utils/enums';
import { Select } from '../../Select';
import { InitiativeValidationSchema } from '../../../validators/initiative';
import { BudgetProjectInitiative } from './BudgetProjectInitiative';
import { ConsultationProposalInitiative } from './ConsultationProposalInitiative';
import { OtherInitiative } from './OtherInitiative';

export class Initiative extends Component {
	constructor(props) {
		super(props);
		this.state = {
			verified: true,
			zoom: props.mapConfiguration.zoom,
			locationLatitude: props.mapConfiguration.latitude,
			locationLongitude: props.mapConfiguration.longitude
		};
		this.map = null;
		this.onVerify = () => {
			this.setState({ verified: true });
		};
		this.onExpire = () => {
			this.setState({ verified: false });
		};
		this.onError = () => {
			this.setState({ verified: false });
		};

		this.zoomEnd = (e) => {
			let zoom = e.target.getZoom();
			this.setState({
				zoom: zoom
			});
		};
		this.dragEnd = (e, callback) => {
			try {
				let position = e.target.getLatLng();

				if (position.lat && position.lng) {
					callback('locationLatitude', position.lat);
					callback('locationLongitude', position.lng);
					this.setState({
						locationLatitude: position.lat,
						locationLongitude: position.lng
					});
				} else {
					console.error('Nie można odczytać współrzędnych');
				}
			} catch (err) {
				console.error('Nie można odczytać współrzędnych');
			}
		};
		this.changeGeoPoint = (e, callback) => {
			const regEx = /^(\-?\d+(\.)?(\d+)?)$/;
			if (regEx.test(e.target.value) || e.target.value === '') {
				this.setState(
					{
						[e.target.name]: e.target.value
					},
					callback(e.target.name, e.target.value)
				);
			}
		};

		this.getComponent = (type) => {
			switch (type) {
				case InitiativeType.BudgetProject:
					return BudgetProjectInitiative;
				case InitiativeType.ConsultationProposal:
					return ConsultationProposalInitiative;
				case InitiativeType.Other:
					return OtherInitiative;
				default:
					return BudgetProjectInitiative;
			}
		};
		this.initiative = null;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.mapConfiguration.zoom !== this.props.mapConfiguration.zoom) {
			this.setState({
				zoom: this.props.mapConfiguration.zoom
			});
		}

		if (prevProps.mapConfiguration.latitude !== this.props.mapConfiguration.latitude) {
			this.setState({
				locationLatitude: this.props.mapConfiguration.latitude
			});
		}
		if (prevProps.mapConfiguration.longitude !== this.props.mapConfiguration.longitude) {
			this.setState({
				locationLongitude: this.props.mapConfiguration.longitude
			});
		}
	}

	async uploadFile(file) {
		let formData = new FormData();
		formData.append('attachment', file);
		try {
			let response = await axios.post('/api/attachments/initiative-attachement', formData);
			return response.data;
		} catch (e) {
			toastr.error('Błąd podczas uploadu pliku', 'Wystąpił niespodziewany błąd podczas uploadu pliku');
			return -1;
		}
	}

	getOptions = () => {
		const { appModule } = this.props;
		const options = [];
		if (appModule.budget) {
			options.push({
				value: InitiativeType.BudgetProject,
				text: 'Projekt budżetu'
			});
		}
		if (appModule.consultation) {
			options.push({
				value: InitiativeType.ConsultationProposal,
				text: 'Propozycja konsultacji'
			});
		}
		options.push({
			value: InitiativeType.Other,
			text: 'Inne'
		});

		return options;
	};
	render() {
		let {
			type,
			title,
			content,
			replyTo,
			attachments,
			thematicAreaId,
			officeId,
			districtId,
			onSubmit,
			isAuth,
			attachmentConfiguration,
			isInitiativeCreating,
			mapConfiguration,
			reCaptchaConfig,
			mode
		} = this.props;
		const thematicAreas = map(this.props.thematicAreas, (thematicArea, i) => ({
			value: thematicArea.id,
			text: thematicArea.name
		})).sort((a, b) => a.text.localeCompare(b.text, 'pl'));
		const districts = map(this.props.districts, (district, i) => ({
			value: district.id,
			text: district.name
		})).sort((a, b) => a.text.localeCompare(b.text, 'pl'));

		return (
			<div className="container consultations">
				<div className="margin-bottom-20">
					<Formik
						enableReinitialize={true}
						validationSchema={InitiativeValidationSchema}
						initialValues={{
							type,
							title,
							content,
							replyTo,
							attachments,
							thematicAreaId,
							officeId,
							districtId,
							isAuth,
							attachmentConfiguration,
							locationLatitude: mapConfiguration.latitude,
							locationLongitude: mapConfiguration.longitude
						}}
						render={({
							values,
							handleChange,
							handleBlur,
							isValid,
							errors,
							setFieldValue,
							isSubmitting,
							setSubmitting
						}) => {
							const initiativeProps = {
								...values,
								mode: mode,
								errors: errors,
								onChange: handleChange,
								onBlur: handleBlur,
								isValid: isValid,
								setFieldValue: setFieldValue,
								districts: districts,
								thematicAreas: thematicAreas,
								map: this.map,
								isAuth: isAuth,
								isInitiativeCreating: isInitiativeCreating,
								zoomEnd: this.zoomEnd,
								dragEnd: this.dragEnd,
								changeGeoPoint: this.changeGeoPoint,
								uploadFile: this.uploadFile,
								onVerify: this.onVerify,
								onExpire: this.onExpire,
								onError: this.onError,
								verified: this.state.verified,
								reCaptchaConfig: reCaptchaConfig,
								stateLocationLatitude: this.state.locationLatitude,
								stateLocationLongitude: this.state.locationLongitude,
								stateZoom: this.state.zoom
							};
							const InitiativeComponent = this.getComponent(values.type);
							return (
								<Form
									method="post"
									onSubmit={async (e) => {
										e.preventDefault();
										setSubmitting(true);
										/* Nie przechodzi walidacji WCAG2.1 */
										// const verified = await this.initiative.verify();
										const verified = true;
										if (verified) {
											values.locationLatitude =
												values.locationLatitude || this.state.locationLatitude;
											values.locationLongitude =
												values.locationLongitude || this.state.locationLongitude;
											values.cost = values.cost ? values.cost.replace(/,/g, '.') : 0;
											onSubmit(values);
											setSubmitting(false);
										} else {
											setSubmitting(false);
										}
									}}
								>
									<Form.Group>
										<div className="field field--input">
											<Form.Label htmlFor="type" className="field__label">
												Typ
											</Form.Label>
											<Select
												id="type"
												name="type"
												options={this.getOptions()}
												value={values.type}
												onSelect={(option) => setFieldValue('type', option.value)}
											/>
										</div>
										{typeof errors.type === 'string' && (
											<Form.Control.Feedback
												type="invalid"
												style={{ display: 'block', color: 'red', marginTop: 10 }}
											>
												{errors.type}
											</Form.Control.Feedback>
										)}
									</Form.Group>
									<InitiativeComponent ref={(ref) => (this.initiative = ref)} {...initiativeProps} />
								</Form>
							);
						}}
					/>
				</div>
			</div>
		);
	}
}

Initiative.defaultProps = {
	type: InitiativeType.BudgetProject,
	title: '',
	content: '',
	replyTo: '',
	attachments: [],
	attachmentConfiguration: {
		maxAttachmentQuantity: 3,
		maxAttachmentSize: 5,
		maxAllAttachmentsSize: 15
	},
	cost: 0,
	thematicAreaId: ThematicAreaDropdownOption.NotSetted,
	districtId: DistrictDropdownOption.NotSetted,
	officeId: DefaultOffice.NotSetted,
	thematicAreas: [],
	districts: [],
	isAuth: false,
	reCaptchaConfig: {
		reCaptchaKey: ''
	},
	isInitiativeCreating: false,
	onSubmit: Function.prototype,
	setFieldValue: Function.prototype
};

// recaptcha key - 6LeO5o4UAAAAACtqupU5rIOHQqQDGFVEUyOXCWO7
